<template>
  <oxd-input-field
    type="select"
    :label="$t('general.job_title')"
    :options="options"
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>

<script>
import {ref, onBeforeMount, watch} from 'vue';
import {APIService} from '@ohrm/core/util/services/api.service';

export default {
  name: 'JobtitleDropdown',
  props: {
    modelValue: {
      type: [Object, Number],
      default: null,
    },
    jobTitleId: {
      type: Number,
      default: null,
    },
  },
  emits: ['update:modelValue'],
  setup(props, {emit}) {
    const options = ref([]);
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/admin/job-titles',
    );

    const autoSelectJobTitle = () => {
      const idToSelect =
        props.jobTitleId ||
        (typeof props.modelValue === 'number' ? props.modelValue : null);

      if (idToSelect && options.value.length > 0) {
        const selectedOption = options.value.find(
          (option) => option.id === idToSelect,
        );
        if (selectedOption) {
          emit('update:modelValue', selectedOption);
        }
      }
    };

    onBeforeMount(() => {
      http.getAll({limit: 0}).then(({data}) => {
        options.value = data.data.map((item) => {
          return {
            id: item.id,
            label: item.title,
          };
        });

        if (props.jobTitleId) {
          autoSelectJobTitle();
        }
      });
    });

    watch(
      () => props.jobTitleId,
      (newJobTitleId) => {
        if (newJobTitleId && options.value.length > 0) {
          autoSelectJobTitle();
        }
      },
    );

    return {
      options,
    };
  },
};
</script>
